<ngb-rating #ratingRef (rateChange)="setRating($event)" [rate]="2">
	<ng-template let-fill="fill">
		<span class="star" [class.filled]="fill === 100">&#9733;</span>
	</ng-template>
</ngb-rating>
